import { ThemeOptions } from '@mui/material/styles';

import { clubCardStyleOverrides, CLUB_ACCENT_GRADIENT } from './cardStyles';

export const acaColors = {
  primary: '#034f9d',
  primaryShade: '#03468a',
  primaryTint: '#1c61a7',
  primaryContrast: '#ffffff',
  backgroundContent: '#f5f6f7',
} as const;

const acaThemeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: acaColors.primary,
      dark: acaColors.primaryShade,
      light: acaColors.primaryTint,
      contrastText: acaColors.primaryContrast,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: `${acaColors.primary} !important`,
          color: acaColors.primaryContrast,
          '& .MuiIconButton-root': { color: acaColors.primaryContrast },
          '& svg path': { fill: acaColors.primaryContrast },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: clubCardStyleOverrides({
          accentImage: CLUB_ACCENT_GRADIENT,
          legacyAccent: CLUB_ACCENT_GRADIENT,
        }),
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: acaColors.primary,
          '&:focus': {
            color: acaColors.primaryShade,
            outline: `solid 2px ${acaColors.primaryShade}`,
          },
          '&:hover': { color: acaColors.primaryShade },
        },
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: 'contained' },
          style: {
            backgroundColor: acaColors.primary,
            '&:focus': {
              border: `1px solid ${acaColors.primaryShade}`,
              backgroundColor: acaColors.primaryShade,
              outline: `solid 2px ${acaColors.primaryShade}`,
              outlineOffset: '1px',
            },
            '&:hover': { backgroundColor: acaColors.primaryShade },
          },
        },
        {
          props: { variant: 'text' },
          style: {
            '&:focus': {
              color: acaColors.primaryShade,
              outline: `solid 2px ${acaColors.primaryShade}`,
              outlineOffset: '1px',
            },
          },
        },
      ],
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          '.MuiSwitch-switchBase.Mui-checked:hover': {
            backgroundColor: `${acaColors.primary}1A`,
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: { '&:focus': { outline: `solid 2px ${acaColors.primaryShade}` } },
      },
    },
  },
};

export default acaThemeOptions;
